import qs, { ParseOptions } from 'query-string';
import { useMemo } from 'react';
import { useLocation } from 'react-router';

interface LocationObject {
  search: string;
}

interface UseQueryStringOptions {
  parseOptions?: ParseOptions;
  location?: LocationObject;
}

export function useQueryString<QueryStringObject extends {}>({
  location = useLocation(),
  parseOptions,
}: UseQueryStringOptions = {}) {
  return useMemo(
    () =>
      qs.parse(
        location.search,
        parseOptions
      ) as unknown as Partial<QueryStringObject>,
    [location]
  );
}
